import PropTypes from 'prop-types';
import { compose, getContext, withPropsOnChange, withState, lifecycle } from 'recompose';
import { GOOGLE, MAP } from './constants';

export const enhance = compose(
	getContext({
		[MAP]: PropTypes.any,
		[GOOGLE]: PropTypes.any
	}),
	withState('polygon', 'setPolygon', null),
	withPropsOnChange(
		[GOOGLE, MAP],
		({
			[GOOGLE]: google, [MAP]: map, polygon, setPolygon, paths, strokeColor, strokeWeight, strokeOpacity,
			fillColor, fillOpacity, visible
		}) => {
			if (google && map && !polygon) {
				const newPoly = new google.maps.Polygon({
					map,
					paths,
					strokeColor,
					strokeOpacity,
					strokeWeight,
					fillColor,
					fillOpacity,
					visible
				});

				setPolygon(newPoly);
			}
		}
	),
	withPropsOnChange(['visible'], ({ polygon, visible }) => {
		if (polygon) {
			polygon.setVisible(visible);
		}
	}),
	lifecycle({
		componentWillUnmount() {
			if (this.props.polygon) {
				this.props.polygon.setMap(null);
			}
		}
	})
);

export function Polygon() { return null; }

Polygon.propTypes = {
	paths: PropTypes.arrayOf(
		PropTypes.oneOfType([
			PropTypes.array,
			PropTypes.object
		])
	).isRequired,
	fillColor: PropTypes.string,
	fillOpacity: PropTypes.number,
	strokeColor: PropTypes.string,
	strokeOpacity: PropTypes.number,
	strokeWeight: PropTypes.number,
	visible: PropTypes.bool
};

export default enhance(Polygon);
